import { Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Tcard } from './mainTcard';
import { TCaredDashboardContext } from '../tCaredDashboard-Provider';

const marginBottom = { marginBottom: 8 };

const TcardMapList = ({
    List = [],
    tCardList,
    toBeScheduledCards,
    classes,
    portalSetting,
    expand,
    handleExpand,
    handleTcardOpen,
    legendItems,
    // Tcard,
    checkIsTcardReadonly
}) => {
    const { shortListByTrailter, setMotColor } = useContext(TCaredDashboardContext);

    return (
        <React.Fragment>
            {List.map((col, index) => {
                let dataList = toBeScheduledCards(tCardList?.tCardStatus);
                let filterList = tCardList?.tCardStatus.filter((m) => m.status === col.status) || [];
                if (col.status === 'TO BE SCHEDULED') {
                    filterList = tCardList?.toSchedule || [];
                    return (
                        <React.Fragment key={index}>
                            <div className="tcard-status-header">
                                <Typography className="tcard-status-title">
                                    <span>{col.status}</span>
                                    <span className="tcard-status-count">
                                        {tCardList?.tCardStatus?.filter((m) => m.status === col.status).length || 0}
                                    </span>
                                </Typography>
                            </div>

                            <div className={`${classes.colHeight} custom-scroll`}>
                                {dataList
                                    .sort(([weekA], [weekB]) => {
                                        const numA = parseInt(weekA.replace(/\D/g, ''), 10);
                                        const numB = parseInt(weekB.replace(/\D/g, ''), 10);
                                        return numA - numB;
                                    })
                                    .map(([week, cards]) => (
                                        <Droppable key={`${col.status}-${week}`} droppableId={`${col.status}-${week}`} direction="vertical">
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                    className={snapshot.isDraggingOver ? 'droppable-active' : ''}
                                                    style={{
                                                        background: portalSetting.portalSettingsIsHolidayColor
                                                    }}
                                                >
                                                    <Typography
                                                        style={{
                                                            fontWeight: 700,
                                                            fontSize: 9.5,
                                                            letterSpacing: '0.3px',
                                                            textTransform: 'uppercase',
                                                            background: portalSetting.portalSettingsIsHolidayBgColor || '#f1f5f9',
                                                            color: portalSetting.portalSettingsIsHolidayColor || '#334155',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            padding: '2px 6px',
                                                            borderTop: '1px solid #e2e8f0',
                                                            borderBottom: '1px solid #e2e8f0'
                                                        }}
                                                    >
                                                        <span>
                                                            {week} - {cards.length}
                                                        </span>
                                                        <span>
                                                            {!expand[week] ? (
                                                                <ExpandMoreIcon
                                                                    onClick={() => handleExpand(week, true)}
                                                                    style={{
                                                                        fontSize: 14,
                                                                        marginRight: 2,
                                                                        cursor: 'pointer'
                                                                    }}
                                                                />
                                                            ) : (
                                                                <ExpandLessIcon
                                                                    onClick={() => handleExpand(week, false)}
                                                                    style={{
                                                                        fontSize: 14,
                                                                        marginRight: 2,
                                                                        cursor: 'pointer'
                                                                    }}
                                                                />
                                                            )}
                                                        </span>
                                                    </Typography>

                                                    {expand[week] &&
                                                        shortListByTrailter(cards).map((k, index) => (
                                                            <Draggable
                                                                key={k.tCardsID}
                                                                isDragDisabled={checkIsTcardReadonly}
                                                                draggableId={k.tCardsID.toString()}
                                                                index={index}
                                                            >
                                                                {(provided, dragSnapshot) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        className={`tcard-drag-item ${dragSnapshot.isDragging ? 'is-dragging' : ''}`}
                                                                        style={{
                                                                            // marginBottom: 8,
                                                                            ...provided.draggableProps.style
                                                                        }}
                                                                    >
                                                                        <Tcard
                                                                            legendItems={legendItems}
                                                                            handleTcardOpen={handleTcardOpen}
                                                                            days={k.days}
                                                                            date={k.dd}
                                                                            customer={k.cust}
                                                                            isLoanVehicle={k.loanVehicle}
                                                                            registration={k.reg}
                                                                            color={k.bgc || k.bg}
                                                                            textColor={k.tc}
                                                                            wn={k.wn}
                                                                            tCardsID={k.tCardsID}
                                                                            vsc={k.vsc}
                                                                            breakdown={k.breakdown}
                                                                            breakdownStatus={k.breakdownStatus}
                                                                            breakdownTime={k.breakdownTime}
                                                                            pt={k.pt}
                                                                            workDetails={k.workDetails}
                                                                            technicians={k.technicians}
                                                                            status={{
                                                                                recall: k.recall,
                                                                                tacho: k.tacho,
                                                                                motdate: k.motdate,
                                                                                motloc: k.motloc,
                                                                                mot: k.mot,
                                                                                repair: k.repair,
                                                                                inspection: k.inspection,
                                                                                cd: k.cd,
                                                                                waiting: k.waiting,
                                                                                service: k.service,
                                                                                ns: k.ns
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))}

                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    ))}
                            </div>

                            {/* Date Not Set Section */}
                            <Droppable droppableId={`${col.status}`} direction="vertical">
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        className={`${classes.colHeight} custom-scroll ${snapshot.isDraggingOver ? 'droppable-active' : ''}`}
                                        style={marginBottom}
                                    >
                                        <div style={{ background: portalSetting.portalSettingsIsHolidayColor }}>
                                            <Typography
                                                style={{
                                                    fontWeight: 700,
                                                    fontSize: 9.5,
                                                    letterSpacing: '0.3px',
                                                    textTransform: 'uppercase',
                                                    background: portalSetting.portalSettingsIsHolidayBgColor || '#f1f5f9',
                                                    color: portalSetting.portalSettingsIsHolidayColor || '#334155',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    padding: '2px 6px',
                                                    borderTop: '1px solid #e2e8f0',
                                                    borderBottom: '1px solid #e2e8f0'
                                                }}
                                            >
                                                <span>Date not set</span>
                                                <span>
                                                    {!expand['notSet'] ? (
                                                        <ExpandMoreIcon
                                                            onClick={() => handleExpand('notSet', true)}
                                                            style={{
                                                                fontSize: 14,
                                                                marginRight: 2,
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    ) : (
                                                        <ExpandLessIcon
                                                            onClick={() => handleExpand('notSet', false)}
                                                            style={{
                                                                fontSize: 14,
                                                                marginRight: 2,
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    )}
                                                </span>
                                            </Typography>

                                            {expand['notSet'] &&
                                                shortListByTrailter(tCardList?.tCardStatus?.filter((m) => m.status === col.status && !m.dd)).map((k, index) => (
                                                    <Draggable
                                                        key={k.tCardsID}
                                                        isDragDisabled={checkIsTcardReadonly}
                                                        draggableId={k.tCardsID.toString()}
                                                        index={index}
                                                    >
                                                        {(provided, dragSnapshot) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className={`tcard-drag-item ${dragSnapshot.isDragging ? 'is-dragging' : ''}`}
                                                                style={{
                                                                    marginBottom: 8,
                                                                    ...provided.draggableProps.style
                                                                }}
                                                            >
                                                                <Tcard
                                                                    legendItems={legendItems}
                                                                    handleTcardOpen={handleTcardOpen}
                                                                    days={k.days}
                                                                    date={k.dd}
                                                                    customer={k.cust}
                                                                    isLoanVehicle={k.loanVehicle}
                                                                    registration={k.reg}
                                                                    color={k.bgc || k.bg}
                                                                    textColor={k.tc}
                                                                    wn={k.wn}
                                                                    tCardsID={k.tCardsID}
                                                                    vsc={k.vsc}
                                                                    breakdown={k.breakdown}
                                                                    breakdownStatus={k.breakdownStatus}
                                                                    breakdownTime={k.breakdownTime}
                                                                    pt={k.pt}
                                                                    workDetails={k.workDetails}
                                                                    technicians={k.technicians}
                                                                    status={{
                                                                        recall: k.recall,
                                                                        tacho: k.tacho,
                                                                        motdate: k.motdate,
                                                                        motloc: k.motloc,
                                                                        mot: k.mot,
                                                                        repair: k.repair,
                                                                        inspection: k.inspection,
                                                                        cd: k.cd,
                                                                        waiting: k.waiting,
                                                                        service: k.service,
                                                                        ns: k.ns
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))}
                                        </div>
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </React.Fragment>
                    );
                }
                if (col.status === 'RECALL') {
                    return (
                        <React.Fragment key={index}>
                            <div className="tcard-status-header">
                                <Typography className="tcard-status-title">
                                    <span>Recall</span>
                                    <span className="tcard-status-count">
                                        {tCardList.recall.length}
                                    </span>
                                </Typography>
                            </div>
                            <div className={`${classes.colHeight} custom-scroll`} style={marginBottom}>
                                {tCardList.tpNames.map((tpName, tpIndex) => (
                                    <div key={tpName}>
                                        <Typography
                                            style={{
                                                padding: '2px 6px',
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                textTransform: 'uppercase',
                                                fontSize: 9.5,
                                                letterSpacing: '0.3px',
                                                backgroundColor: '#e0f2fe',
                                                color: '#0369a1',
                                                borderTop: '1px solid #bae6fd',
                                                borderBottom: '1px solid #bae6fd',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                position: 'relative'
                                            }}
                                        >
                                            <span>{tpName}</span>
                                            {tpName == 'Next Inspection' && (
                                                <span style={{ position: 'absolute', right: 4, display: 'flex', alignItems: 'center' }}>
                                                    {!expand[tpName] ? (
                                                        <ExpandMoreIcon
                                                            onClick={() => handleExpand(tpName, true)}
                                                            style={{
                                                                fontSize: 14,
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    ) : (
                                                        <ExpandLessIcon
                                                            onClick={() => handleExpand(tpName, false)}
                                                            style={{
                                                                fontSize: 14,
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    )}
                                                </span>
                                            )}
                                        </Typography>

                                        <Droppable droppableId={col.status} direction="vertical">
                                            {(provided, snapshot) => {
                                                const items = tCardList.recall.filter((m) => m.tp === tpName);

                                                return (
                                                    <div ref={provided.innerRef} {...provided.droppableProps} className={snapshot.isDraggingOver ? 'droppable-active' : ''}>
                                                        {items.length === 0 && !snapshot.isDraggingOver && (
                                                            <div className={classes.noRecordFound}>No Record Found</div>
                                                        )}

                                                        <div></div>

                                                        {items.map((k, index) => (
                                                            <Draggable
                                                                key={k.tCardsID}
                                                                isDragDisabled={checkIsTcardReadonly}
                                                                draggableId={k.tCardsID.toString()}
                                                                index={index}
                                                            >
                                                                {(provided, dragSnapshot) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        className={`tcard-drag-item ${dragSnapshot.isDragging ? 'is-dragging' : ''}`}
                                                                        style={{
                                                                            // marginBottom: 8,
                                                                            ...provided.draggableProps.style
                                                                        }}
                                                                    >
                                                                        {tpName == 'Next Inspection' ? (
                                                                            expand[k.tp] && (
                                                                                <Tcard
                                                                                    legendItems={legendItems}
                                                                                    handleTcardOpen={handleTcardOpen}
                                                                                    days={k.days}
                                                                                    date={k.bd}
                                                                                    customer={k.cust}
                                                                                    isLoanVehicle={k.loanVehicle}
                                                                                    registration={k.reg}
                                                                                    bg={k.bg}
                                                                                    wn={k.wn}
                                                                                    color={k.bgc || k.bg}
                                                                                    textColor={k.tc}
                                                                                    tCardsID={k.tCardsID}
                                                                                    vsc={k.vsc}
                                                                                    breakdown={k.breakdown}
                                                                                    breakdownStatus={k.breakdownStatus}
                                                                                    breakdownTime={k.breakdownTime}
                                                                                    pt={k.pt}
                                                                                    workDetails={k.workDetails}
                                                                                    technicians={k.technicians}
                                                                                    status={{
                                                                                        recall: k.recall,
                                                                                        tacho: k.tacho,
                                                                                        motdate: k.motdate,
                                                                                        motloc: k.motloc,
                                                                                        mot: k.mot,
                                                                                        repair: k.repair,
                                                                                        inspection: k.inspection,
                                                                                        cd: k.cd,
                                                                                        waiting: k.waiting,
                                                                                        service: k.service,
                                                                                        ns: k.ns
                                                                                    }}
                                                                                />
                                                                            )
                                                                        ) : (
                                                                            <Tcard
                                                                                legendItems={legendItems}
                                                                                handleTcardOpen={handleTcardOpen}
                                                                                date={k.bd}
                                                                                days={k.days}
                                                                                customer={k.cust}
                                                                                isLoanVehicle={k.loanVehicle}
                                                                                registration={k.reg}
                                                                                bg={k.bg}
                                                                                wn={k.wn}
                                                                                color={k.bgc || k.bg}
                                                                                textColor={k.tc}
                                                                                tCardsID={k.tCardsID}
                                                                                vsc={k.vsc}
                                                                                breakdown={k.breakdown}
                                                                                breakdownStatus={k.breakdownStatus}
                                                                                breakdownTime={k.breakdownTime}
                                                                                pt={k.pt}
                                                                                workDetails={k.workDetails}
                                                                                technicians={k.technicians}
                                                                                status={{
                                                                                    recall: k.recall,
                                                                                    tacho: k.tacho,
                                                                                    motdate: k.motdate,
                                                                                    motloc: k.motloc,
                                                                                    mot: k.mot,
                                                                                    repair: k.repair,
                                                                                    inspection: k.inspection,
                                                                                    cd: k.cd,
                                                                                    waiting: k.waiting,
                                                                                    service: k.service,
                                                                                    ns: k.ns
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))}

                                                        {items.length - 1 === index && snapshot.isDraggingOver && items.length > 0 && (
                                                            <div className={`${classes.noRecordFound} is-drag-target`}>Drop Here</div>
                                                        )}
                                                        {provided.placeholder}
                                                    </div>
                                                );
                                            }}
                                        </Droppable>
                                    </div>
                                ))}
                            </div>
                        </React.Fragment>
                    );
                } else {
                    return (
                        <React.Fragment key={index}>
                            <div className="tcard-status-header">
                                <Typography className="tcard-status-title">
                                    <span>{col.status}</span>
                                    <span className="tcard-status-count">
                                        {filterList?.length || 0}
                                    </span>
                                </Typography>
                            </div>

                            <Droppable droppableId={col.status} direction="vertical">
                                {(provided, snapshot) => {
                                    const filteredCards = tCardList?.tCardStatus?.filter((m) => m.status === col.status) || [];

                                    let sortList = shortListByTrailter(filteredCards);

                                    return (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            className={`${classes.colHeight} custom-scroll ${snapshot.isDraggingOver ? 'droppable-active' : ''}`}
                                            style={marginBottom}
                                        >
                                            {sortList.length === 0 && (
                                                <div className={`card-body-container-main-wrapper-no-record ${snapshot.isDraggingOver ? 'is-drag-target' : ''}`}>
                                                    <span>{snapshot.isDraggingOver ? 'Drop Here' : 'No Record Found'}</span>
                                                </div>
                                            )}

                                            {sortList.map((k, index) => (
                                                <Draggable
                                                    key={k.tCardsID}
                                                    isDragDisabled={checkIsTcardReadonly}
                                                    draggableId={k.tCardsID.toString()}
                                                    index={index}
                                                >
                                                    {(provided, dragSnapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={`tcard-drag-item ${dragSnapshot.isDragging ? 'is-dragging' : ''}`}
                                                            style={{
                                                                // marginBottom: 8,
                                                                ...provided.draggableProps.style
                                                            }}
                                                        >
                                                            <Tcard
                                                                legendItems={legendItems}
                                                                handleTcardOpen={handleTcardOpen}
                                                                days={k.days}
                                                                date={k.bd}
                                                                customer={k.cust}
                                                                isLoanVehicle={k.loanVehicle}
                                                                registration={k.reg}
                                                                color={k.bgc || k.bg}
                                                                textColor={k.tc}
                                                                tCardsID={k.tCardsID}
                                                                wn={k.wn}
                                                                vsc={k.vsc}
                                                                breakdown={k.breakdown}
                                                                breakdownStatus={k.breakdownStatus}
                                                                breakdownTime={k.breakdownTime}
                                                                pt={k.pt}
                                                                workDetails={k.workDetails}
                                                                technicians={k.technicians}
                                                                status={{
                                                                    recall: k.recall,
                                                                    tacho: k.tacho,
                                                                    motloc: k.motloc,
                                                                    mot: k.mot,
                                                                    repair: k.repair,
                                                                    inspection: k.inspection,
                                                                    cd: k.cd,
                                                                    waiting: k.waiting,
                                                                    service: k.service,
                                                                    ns: k.ns
                                                                }}
                                                            />
                                                            {snapshot.isDraggingOver && filteredCards.length > 0 && (
                                                                <div className={'card-body-container-main-wrapper-no-record is-drag-target'}>
                                                                    <span>Drop Here</span>
                                                                </div>
                                                            )}
                                                            {provided.placeholder}
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                        </div>
                                    );
                                }}
                            </Droppable>
                        </React.Fragment>
                    );
                }
            })}
        </React.Fragment>
    );
};

export default TcardMapList;
